import { invalidateQuickSearchCache } from '../hooks/useGlobalQuickSearch';
import { clearPagedSearchCache } from '../hooks/usePagedQuickSearch';
import { invalidateDeepLinkCache } from '../utils/deeplink/useDeepLinkFetch';
import studentAlertService from './studentAlertservice';

/** Dispatched when auth is confirmed dead (e.g. 401 login-required). Idle handler listens to close extend prompts. */
export const SESSION_EXPIRED_EVENT = 'elements:session-expired';

class AuthService {
  login(cb) {
    cb();
  }

  logout(cb) {
    this.clearAuthentication();
    cb();
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }

  setAccessAndRefreshToken(data) {
    const { token, refreshToken = null } = data;
    try {
      localStorage.setItem('access_token', token);
      localStorage.setItem('refresh_token', refreshToken);
    } catch (error) {
      return false;
    }
    return true;
  }

  isTokenAvailable() {
    const token = localStorage.getItem('access_token');
    return Boolean(token && token !== 'null' && token !== 'undefined');
  }

  // True only when a token exists and (if JWT) is not past exp.
  // Used for idle-extend / 403 decisions where a stale token must count as logged out.
  isSessionActive() {
    if (!this.isTokenAvailable()) {
      return false;
    }
    const token = localStorage.getItem('access_token');
    try {
      const parts = token.split('.');
      if (parts.length < 2) {
        return true;
      }
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(base64));
      if (typeof payload.exp === 'number') {
        return payload.exp * 1000 > Date.now();
      }
    } catch (_) {
      // Opaque/non-JWT tokens: presence is the best signal we have.
    }
    return true;
  }

  setProfile(user,userId,authMode, userName,acadHold,busnHold,batchAccessRestricted,ssnVisibility,superUser,campusID) {
    localStorage.setItem("username", user)
    localStorage.setItem("userId", userId)
    localStorage.setItem('authMode', authMode);
    localStorage.setItem('user', userName)
    localStorage.setItem('acadHold', acadHold)
    localStorage.setItem('busnHold', busnHold)
    localStorage.setItem('batchAccessRestricted', batchAccessRestricted)
    localStorage.setItem('ssnVisiblitiyMode', ssnVisibility);
    localStorage.setItem('superUser', superUser)
    localStorage.setItem('campusID', campusID);
  }

  clearAuthentication() {
    try { invalidateQuickSearchCache(); } catch (_) { /* defensive */ }
    try { clearPagedSearchCache(); } catch (_) { /* defensive */ }
    try { invalidateDeepLinkCache(); } catch (_) { /* defensive */ }
    try { studentAlertService.clearAlertFlag(); } catch (_) { /* defensive */ }
    localStorage.clear();
  }
}

export default new AuthService();